import { render, staticRenderFns } from "./ListReceptionProducts.vue?vue&type=template&id=2836b240"
import script from "./ListReceptionProducts.vue?vue&type=script&lang=js"
export * from "./ListReceptionProducts.vue?vue&type=script&lang=js"
import style0 from "./ListReceptionProducts.vue?vue&type=style&index=0&id=2836b240&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports